import { FC, ReactElement, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { IResponseProductModifier, IResponseProductModifierOption } from 'src/types/products';
import Text from 'src/view/components/Text/Text';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

interface IProps {
  modifiers: IResponseProductModifier[] | undefined;
}

export const OrderCartProductModifiers: FC<IProps> = observer((props: IProps): ReactElement | null => {
  const options = useMemo((): IResponseProductModifierOption[] => {
    if (!props.modifiers?.length) return [];

    return props.modifiers.reduce((sum: IResponseProductModifierOption[], { options = [] }: IResponseProductModifier) => {
      const selectedOptions = options.filter((option) => option.selected);

      return sum.concat(selectedOptions);
    }, []);
  }, [props.modifiers]);

  if (!options.length) return null;

  return (
    <div className="order-cart-product-modifiers">
      <p className="order-cart-product-modifiers__header letter-spacing-12">{localeStore.t('modifiers')}</p>

      {options.map((option) => (
        <Text key={option.id} type="cart-option" text={option.name} quantity={option.quantity} />
      ))}
    </div>
  );
});
